/**
 * Auth User Reducers
 */
import { SET_ORDER_SUPPORT_CONFIG, SET_ORDER_SUPPORT_CHECKLISTS } from 'Actions/types';

/**
 * Initial Config
 */
const INIT_STATE = {
  config: {},
  checkList: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ORDER_SUPPORT_CONFIG:
      return { ...state, config: action.payload };
    case SET_ORDER_SUPPORT_CHECKLISTS:
      return { ...state, checkList: action.payload };
    default:
      return state;
  }
};
